<div id="receiverDetails" class="pr-2" [formGroup]="shipmentForm">
  <div class="row">
    <div class="col-5">
      <div class="secondary-details mb-2">
        <span>{{ 'shipment.receiver.receiverDetails' | translate }}</span>
      </div>
    </div>
    <div class="col-7 d-flex flex-direction-row align-items-end justify-content-end">
      <div class="d-flex mb-0 ms-4 mr-2 form-group">
        <mat-checkbox
          (change)="showHideEmailAdd($event.checked)"
          formControlName="shipmentNotification"
          class="text-wrap"
          id="checkbox">
          {{ 'shipment.receiver.receiveEmailNotification' | translate }}
        </mat-checkbox>
      </div>
      <div *ngIf="showEmailAdd" class="d-flex">
        <button
          class="me-1 icon-mat-button"
          (click)="openPreAlertSetting()"
          #tooltip="matTooltip"
          [matTooltip]="'shipment.receiver.emailButtonTooltipLabel' | translate"
          mat-raised-button>
          <em class="bi bi-envelope-check-fill"></em>
        </button>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="row" formGroupName="receiverDetails">
      <div class="col-md-6 form-group">
        <label class="required-field">{{ 'shipment.receiver.companyName' | translate }}</label
        >:
        <em
          *ngIf="shipmentStatus !== 'Manifested'"
          class="bi bi-person-rolodex icon-mat"
          (click)="openAddress('RECEIVER')"
          #tooltip="matTooltip"
          [matTooltip]="'shipment.receiver.selectFromExistingAddress' | translate"></em>
        <input class="form-control" type="text" formControlName="receiverCompanyName" />
        <app-error-component
          [controlName]="shipmentForm.get('receiverDetails').get('receiverCompanyName')">
        </app-error-component>
      </div>
      <div class="col-md-6 form-group">
        <label class="required-field">{{ 'shipment.receiver.contactPersonName' | translate }}</label
        >:
        <input
          specialIsAlphaNumeric
          class="form-control"
          type="text"
          formControlName="receiverContactPersonName" />
        <app-error-component
          [controlName]="
            shipmentForm.get('receiverDetails').get('receiverContactPersonName')
          "></app-error-component>
      </div>
      <div class="col-md-6 form-group">
        <label class="required-field">{{ 'shipment.receiver.addressLine1' | translate }}</label
        >:

        <input
          specialIsAlphaNumeric
          class="form-control"
          type="text"
          formControlName="receiverAddressLine1" />
        <app-error-component
          [controlName]="
            shipmentForm.get('receiverDetails').get('receiverAddressLine1')
          "></app-error-component>
      </div>
      <div class="col-md-6 form-group">
        <label>{{ 'shipment.receiver.addressLine2' | translate }}: </label>
        <input
          specialIsAlphaNumeric
          class="form-control"
          type="text"
          formControlName="receiverAddressLine2" />
        <app-error-component
          [controlName]="
            shipmentForm.get('receiverDetails').get('receiverAddressLine2')
          "></app-error-component>
      </div>
      <div class="col-md-6 form-group">
        <label>{{ 'shipment.receiver.addressLine3' | translate }}: </label>
        <input
          specialIsAlphaNumeric
          class="form-control"
          type="text"
          formControlName="receiverAddressLine3" />
        <app-error-component
          [controlName]="
            shipmentForm.get('receiverDetails').get('receiverAddressLine3')
          "></app-error-component>
      </div>
      <div class="col-md-6 form-group address">
        <label class="required-field">{{ 'shipment.receiver.countryName' | translate }}: </label>
        <mat-form-field class="w-100" style="font-size: 14px" appearance="outline">
          <input
            matInput
            type="text"
            formControlName="receiverCountryName"
            [matAutocomplete]="auto" />

          <mat-autocomplete
            (optionSelected)="selectionChanged($event?.option.value)"
            #auto="matAutocomplete">
            <mat-option *ngFor="let item of list" [value]="item?.name">
              {{ item?.name }}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>

        <app-error-component
          [controlName]="
            shipmentForm.get('receiverDetails').get('receiverCountryName')
          "></app-error-component>
      </div>

      <div class="col-md-6 form-group address">
        <label
          [ngClass]="{
            'required-field': isPostalCodeReq === true
          }"
          >{{ 'shipment.receiver.postalCode' | translate }}</label
        >:

        <mat-form-field class="w-100" style="font-size: 14px" appearance="outline">
          <input
            matInput
            type="text"
            formControlName="receiverPostalCode"
            [matAutocomplete]="autoPostalCode" />

          <mat-autocomplete #autoPostalCode="matAutocomplete">
            <mat-option
              *ngFor="let item of cityList"
              (onSelectionChange)="selectionPincodeChanged($event, item)"
              [value]="item?.postalCode">
              {{ item?.postalCode }}<span *ngIf="item?.city">,</span> {{ item?.city }}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>

        <app-error-component
          [controlName]="
            shipmentForm.get('receiverDetails').get('receiverPostalCode')
          "></app-error-component>
        <span class="msg" *ngIf="!isPostalCodeValid">{{
          'shipment.receiver.invalidPostalCode' | translate
        }}</span>
      </div>

      <div class="col-md-6 form-group address">
        <label class="required-field">{{ 'shipment.receiver.cityName' | translate }}</label
        >:

        <mat-form-field class="w-100" style="font-size: 14px" appearance="outline">
          <input
            matInput
            type="text"
            formControlName="receiverCityName"
            [matAutocomplete]="autoCity" />

          <mat-autocomplete #autoCity="matAutocomplete">
            <mat-option
              *ngFor="let item of cityList"
              (onSelectionChange)="selectionCityChanged($event, item)"
              [value]="item?.city">
              {{ item?.city }}<span *ngIf="item?.postalCode">,</span> {{ item?.postalCode }}
              <span *ngIf="item?.cityDistrict">,</span> {{ item?.cityDistrict }}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>

        <app-error-component
          [controlName]="
            shipmentForm.get('receiverDetails').get('receiverCityName')
          "></app-error-component>
        <span class="msg" *ngIf="!isCityValid || !isRecPostalValidated">{{
          'shipment.receiver.invalidCityName' | translate
        }}</span>
      </div>

      <div class="col-md-6 form-group">
        <label class="required-field">{{ 'shipment.receiver.countryCode' | translate }}</label
        >:
        <input
          specialIsAlphaNumeric
          class="form-control"
          type="text"
          formControlName="receiverCountryCode" />
        <app-error-component
          [controlName]="
            shipmentForm.get('receiverDetails').get('receiverCountryCode')
          "></app-error-component>
      </div>
      <div class="col-md-6 form-group">
        <label>{{ 'shipment.receiver.suburb' | translate }}</label
        >:
        <input class="form-control" type="text" formControlName="receiversuburb" />
        <app-error-component
          [controlName]="
            shipmentForm.get('receiverDetails').get('receiversuburb')
          "></app-error-component>
      </div>
      <div class="col-md-6 form-group">
        <label>{{ 'shipment.receiver.provinceCode' | translate }}: </label>
        <input
          specialIsAlphaNumeric
          class="form-control"
          type="text"
          formControlName="receiverProvinceCode" />
        <app-error-component
          [controlName]="
            shipmentForm.get('receiverDetails').get('receiverProvinceCode')
          "></app-error-component>
      </div>

      <div class="col-md-6 form-group">
        <label class="required-field">{{ 'shipment.receiver.phone' | translate }}</label
        >:
        <input
          specialIsAlphaNumeric
          class="form-control"
          type="text"
          formControlName="receiverPhone" />
        <app-error-component
          [controlName]="
            shipmentForm.get('receiverDetails').get('receiverPhone')
          "></app-error-component>
      </div>

      <div class="col-md-6 form-group">
        <label>{{ 'shipment.receiver.email' | translate }}: </label>
        <input
          specialIsAlphaNumeric
          class="form-control"
          type="text"
          formControlName="receiverEmail" />
        <app-error-component
          [controlName]="
            shipmentForm.get('receiverDetails').get('receiverEmail')
          "></app-error-component>
      </div>
    </div>
  </div>
</div>
